import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Pipe({ name: 'dateFormat' })
export class DateFormatPipe extends DatePipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private _locale: string,
              private translate: TranslateService) {
    super(_locale);
  }

  private static isSameDay(now: Date, value: Date): boolean {
    return (
      now.getUTCDate() === value.getUTCDate() &&
      now.getUTCMonth() === value.getUTCMonth() &&
      now.getUTCFullYear() === value.getUTCFullYear()
    );
  }

  transform(value: Date): any {
    value = new Date(value);
    let day: string;
    const now = new Date();
    const today = DateFormatPipe.isSameDay(now, value);
    if (today) {
      day = this.translate.instant('CALENDAR.TODAY');
    } else {
      now.setDate(now.getDate() - 1);
      const yesterday = DateFormatPipe.isSameDay(now, value);
      if (yesterday) {
        day = this.translate.instant('CALENDAR.YESTERDAY');
      } else {
        now.setDate(now.getDate() + 2);
        const dayBefore = DateFormatPipe.isSameDay(now, value);
        if (dayBefore) {
          day = this.translate.instant('CALENDAR.TOMORROW');
        } else {
          day = this.translate.instant('CALENDAR.THE_DAY_OF_MONTH',
              { dayOfMonth: super.transform(value, 'dd MMMM') });
        }
      }
    }
    return `${day}, ${super.transform(value, 'HH')} h ${super.transform(value, 'mm')}`;
  }
}
